export const FormularModelMetaCompanyDataSchema = {
    $id: "FormularModelMetaCompanyDataSchema",
    title: "FormularModelMetaCompanyData Schema",
    type: "object",
    properties: {
        Name: { type: "string", nullable: true },
        Street: { type: "string", nullable: true },
        PostCode: { type: "string", nullable: true },
        City: { type: "string", nullable: true },
        Phone: { type: "string", nullable: true },
        Fax: { type: "string", nullable: true },
        Mail: { type: "string", nullable: true },
        WebsiteUrl: { type: "string", nullable: true },
        Motto: { type: "string", nullable: true },
        LogoSrc: { type: "string", nullable: true },
        CEO: { type: "string", nullable: true },
        FiscalTaxID: { type: "string", nullable: true },
        VatTaxID: { type: "string", nullable: true },
        TaxOffice: { type: "string", nullable: true },
        CommercialRegisterEntry: { type: "string", nullable: true },
        Bankname: { type: "string", nullable: true },
        IBAN: { type: "string", nullable: true },
        BIC: { type: "string", nullable: true }
    }
}